// pages/setup/components/Tooltip.tsx
import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Info } from 'lucide-react';

interface TooltipProps {
    text: string;
}

export function Tooltip({ text }: TooltipProps) {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const iconRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isVisible && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            const tooltipWidth = 224; // w-56 = 224px

            setPosition({
                top: rect.bottom + 4,
                left: Math.max(8, rect.left + rect.width / 2 - tooltipWidth / 2)
            });
        }
    }, [isVisible]);

    const tooltipContent = isVisible && (
        <div
            className="fixed z-[99999] w-56 p-2 text-xs text-white bg-gray-900 rounded-lg shadow-lg pointer-events-none"
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
            }}
        >
            {text}
        </div>
    );

    return (
        <>
            <div
                ref={iconRef}
                className="inline-block ml-1 cursor-help"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
            >
                <Info className="h-3.5 w-3.5 text-gray-400" />
            </div>
            {tooltipContent && createPortal(tooltipContent, document.body)}
        </>
    );
}